export const alert = {
    error: { value: "error", title: "Erro" },
    warning: { value: "warning", title: "Atenção" },
    info: { value: "info", title: "Detalhes" },
    success: { value: "success", title: "Sucesso" },
}